module.exports = __webpack_public_path__ + "static/media/orez.1ce86307.jpg";